var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "header" }, [
    _vm.android
      ? _c(
          "a",
          {
            staticClass: "logo fl",
            attrs: { href: this.$config.androidAPPUrl },
            on: { click: _vm.handleEvent },
          },
          [_c("img", { attrs: { alt: "LMK", src: "/public/logo_v2.png" } })]
        )
      : _c(
          "a",
          {
            staticClass: "logo fl",
            attrs: { href: this.$config.iOSAPPUrl },
            on: { click: _vm.handleEvent },
          },
          [_c("img", { attrs: { alt: "LMK", src: "/public/logo_v2.png" } })]
        ),
    _vm._v(" "),
    _c("p", { staticClass: "name" }, [_vm._v("LMK - Anonymous Messages")]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _vm.ios
      ? _c(
          "a",
          {
            staticClass: "btn-open",
            attrs: { href: this.$config.iOSAPPUrl },
            on: { click: _vm.handleEvent },
          },
          [_vm._v("GET")]
        )
      : _vm.android
      ? _c(
          "a",
          {
            staticClass: "btn-open",
            attrs: { href: this.$config.androidAPPUrl },
            on: { click: _vm.handleEvent },
          },
          [_vm._v("GET")]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "meta" }, [
      _c("img", { attrs: { src: "/public/stars.png" } }),
      _vm._v("2.2k reviews"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// src/components/common/HeaderAppstore.vue